export function StethoscopeIcon({ ...rest }) {
  return (
    <svg
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4.5 2.5h-.8a1.7 1.7 0 0 0-1.7 1.7v4.6a5.5 5.5 0 0 0 11 0V4.2a1.7 1.7 0 0 0-1.7-1.7h-.8" />
      <path d="M7.5 14.3v1.5a5.2 5.2 0 0 0 10.4 0v-3.2" />
      <circle cx="17.9" cy="10.4" r="2.2" />
    </svg>
  );
}
